import { Icon } from '@iconify-icon/react';
import { memo } from 'react';

/**
 * Props:
 *  icon: "mdi:book-open" etc.
 *  size?: number
 *  color?: CSS color string
 *  sx?: style object
 */
export default memo(function IconRuntime({ icon, size = 32, color, sx }) {
	return <Icon icon={icon} width={size} height={size} style={{ color, ...(sx || {}) }} />;
});
